import { render } from "./TaskSubtasks.vue?vue&type=template&id=a4b9119a&scoped=true"
import script from "./TaskSubtasks.vue?vue&type=script&lang=js"
export * from "./TaskSubtasks.vue?vue&type=script&lang=js"

import "./TaskSubtasks.vue?vue&type=style&index=0&id=a4b9119a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b9119a"]])

export default __exports__